import {
  CreateMeasurementMutation,
  CreateMeasurementMutationVariables,
  MeasurementRefFragment,
  MeasurementRefsDocument,
  MetricsV1MeasurementInput,
  useCreateMeasurementMutation,
  withStandardCreateHook,
} from '@spotify/confidence-graphql';

export const useCreateMeasurement = withStandardCreateHook<
  CreateMeasurementMutation,
  MeasurementRefFragment,
  'createMeasurement',
  CreateMeasurementMutationVariables,
  [MetricsV1MeasurementInput]
>(
  useCreateMeasurementMutation,
  'createMeasurement',
  (measurement: MetricsV1MeasurementInput) => ({ measurement }),
  {
    refetchQueries: [MeasurementRefsDocument],
    awaitRefetchQueries: true,
  },
);
